import {
    NestedPageLayout
} from 'shared/components/NewDesignComponents/PageLayout';
import Breadcrumb from 'shared/components/Breadcrumb';
import React, {
    useContext, useEffect, useState
} from 'react';
import {
    Card, CardContent, CardDescription, CardHeader, CardTitle
} from 'shared/components/ui/card';
import {
    Textarea
} from 'shared/components/ui/textarea';
import {
    Label
} from 'shared/components/ui/label';
import {
    Context
} from 'shared/context/GlobalState';
import {
    Input
} from 'shared/components/ui/input';
import {
    OpCodeBuilderContext
} from '../context/OpCodeBuilderContext';
import JsonOpcodeExecute from './JsonOpcodeExecute';
import {
    jsonOpcodeService
} from 'shared/api/services/BEX/jsonOpcode.service';
import {
    useParams,
    useNavigate
} from 'react-router-dom';
import {
    RedisJSONOpcode
} from './types';
import {
    Button
} from 'shared/components/ui/button';
import {
    Cog
} from 'lucide-react';

const JsonOpcodeViewAndExecute = () => {
    const {
        addNewNotifcation
    } = useContext(Context);
    const [loadingDetails, setLoadingDetails] = useState(false);
    const [opCode, setOpCode] = useState<RedisJSONOpcode | null>(null);
    const {
        orgId, subOrgId
    } = useContext(OpCodeBuilderContext);
    const {
        opcodeId
    } = useParams<{ opcodeId: string }>();
    const navigate = useNavigate();

    useEffect(() => {
        if (opcodeId) {
            initializeOpcode();
        }
    }, [opcodeId]);

    const handleNavigateToUpdate = () => {
        if (orgId && subOrgId && opcodeId) {
            navigate(`/organizations/${orgId}/sub/${subOrgId}/op-codes/json/${opcodeId}`);
        }
    };

    const initializeOpcode = async () => {
        if (!orgId || !subOrgId || !opcodeId) {
            addNewNotifcation('Missing organization, sub-organization, or opcode ID.', 'danger');
            return;
        }

        try {
            setLoadingDetails(true);

            const res = await jsonOpcodeService.getJSONOpcodeById({
                organizationId: orgId,
                subOrganizationId: subOrgId,
                opcodeId
            });
            const details = res.data as RedisJSONOpcode;
            if (details?.opcode_id || details?._id) {
                setOpCode(details);
            }

        } catch (error) {
            console.error('Error getting JSON opcode details:', error);
            const err = error as { response?: { data?: unknown } };
            const responseData = err.response?.data;
            if (typeof responseData === 'string' && responseData === 'Opcode not found') {
                addNewNotifcation(`No JSON opcode found with this ID "${opcodeId}"`, 'danger');
            } else {
                addNewNotifcation('Failed to retrieve JSON opcode details. Please try again.', 'danger');
            }
        } finally {
            setLoadingDetails(false);
        }
    };

    return (
        <NestedPageLayout>
            <div className='my-3'>
                <Breadcrumb maxPaths={2} />
            </div>

            <Card>
                <CardHeader className="flex justify-between">
                    <div className="flex justify-between w-full">
                        <div className="">
                            <CardTitle>View and Execute JSON OpCode</CardTitle>
                            <CardDescription className='mt-1 flex flex-col'>
                                You are viewing the JSON opcode: {loadingDetails ? 'Loading Details...' : (opCode?.title || opCode?.name || '')}
                                {loadingDetails ? '' : opCode ? '' : (
                                    <span className='text-red-400'>Failed to load JSON opcode, please try again later</span>
                                )}
                            </CardDescription>
                        </div>
                        <Button
                            variant="default"
                            size="sm"
                            onClick={handleNavigateToUpdate}
                            className="gap-2"
                            disabled={!opcodeId}
                        >
                            <Cog className="h-4 w-4" />
                            Update Opcode
                        </Button>
                    </div>
                </CardHeader>
                <CardContent>
                    <div className="space-y-2">
                        <div>
                            <Label>Opcode Name</Label>
                            <Input value={opCode?.title || opCode?.name || ''} readOnly className="font-bold"/>
                        </div>
                        {opCode?.description && (
                            <div>
                                <Label>Opcode Description</Label>
                                <Textarea className="min-h-[100px]" readOnly value={opCode.description || ''} />
                            </div>
                        )}
                        <JsonOpcodeExecute opCode={opCode} />
                    </div>
                </CardContent>
            </Card>

        </NestedPageLayout>
    );
};

export default JsonOpcodeViewAndExecute;
